import { Component, Input } from '@angular/core';
import { ITableColumn } from '../../models/table-column';
import { LsqBaseColumnComponent } from './base-column.component';

@Component({
    selector: 'lsq-hidden-column',
    template: `
        <ng-container [cdkColumnDef]="column.key">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                class="hidden-cell"
                [ngStyle]="{ width: width || column.width }"
            ></th>
            <td
                cdk-cell
                *cdkCellDef
                class="hidden-cell"
                [ngStyle]="{ width: width || column.width }"
            ></td>
            <td cdk-footer-cell *cdkFooterCellDef [ngStyle]="{ width: width || column.width }">
                <!-- Render empty footer cell if no custom is provided. -->

                <!-- Custom Column Cell Footer -->
                <div *ngFor="let customFooter of customColumnFooters">
                    <ng-container
                        *ngTemplateOutlet="customFooter.templateRef; context: { row: row }"
                    ></ng-container>
                </div>
            </td>
        </ng-container>
    `
})
export class LsqHiddenColumnComponent extends LsqBaseColumnComponent {
    @Input() public width: string;
    // If a table has multiple hidden cols, must pass in a column with unique 'key'.
    @Input() public column: ITableColumn = {
        key: 'hidden',
        width: '1rem'
    };
}
